import { ShopifyInactiveSubscriptionResponse } from "./types";

/**
 * True when GET /subscription returned the limited Shopify inactive payload
 * instead of a full lite/detailed subscription.
 */
export const isShopifyInactiveSubscriptionResponse = (
  data: unknown
): data is ShopifyInactiveSubscriptionResponse => {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const record = data as Record<string, unknown>;

  return (
    typeof record.entity_id === "string" &&
    typeof record.redirect_url === "string" &&
    !("status" in record) &&
    !("entitlements" in record)
  );
};
